class keyEvent {
    constructor(props) {
        this.key = props.key;
        this.ctrlKey = props.ctrlKey || false;
        this.altKey = props.altKey || false;
        this.shiftKey = props.shiftKey || false;
        this.callback = props.callback;
        this.uniqueId = props.uniqueId || null;
    }
}

export default new class Keymap {
    constructor() {
        this.bindings = [];

        window.addEventListener("keydown", (e) => {
            var evtobj = window.event ? event : e;
            if (["INPUT", "TEXTAREA"].indexOf(evtobj.target.tagName) > -1 
                || evtobj.target.classList.contains("note-editable")
                || evtobj.target.className.indexOf("ck-editor") !== -1
                || evtobj.target.classList.contains("ck-content")) return;
            this.bindings.forEach((evt) => {
                if (e.key.toLowerCase() === evt.key.toLowerCase()
                    && (e.ctrlKey === evt.ctrlKey || e.metaKey === evt.ctrlKey)
                    && e.altKey === evt.altKey
                    && e.shiftKey === evt.shiftKey) {
                    evt.callback(e);
                }
            })
        })
    }

    add({key, ctrlKey, altKey, shiftKey, callback, uniqueId}) {
        if (typeof key === "string" && typeof callback === "function") {
            if (uniqueId && this.bindings.find(b => b.uniqueId === uniqueId)) {
                return
            }
            this.bindings.push(new keyEvent({key, ctrlKey, altKey, shiftKey, callback, uniqueId}))
        } else {
            console.error("wrong keymap options");
        }
    }

    remove() {

    }
}